/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogRef,
  CatalogRefOptional,
  CatalogRefMetaI,
  CatalogRefTrackedI,
} from "./catalog-ref";
import { CatalogRefTracked, CatalogRefMeta } from "./catalog-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DiscountBase,
  DiscountBaseOptional,
  DiscountBaseMetaI,
  DiscountBaseTrackedI,
} from "./discount-base";
import { DiscountBaseTracked, DiscountBaseMeta } from "./discount-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DiscountCategoryRef,
  DiscountCategoryRefOptional,
  DiscountCategoryRefMetaI,
  DiscountCategoryRefTrackedI,
} from "./discount-category-ref";
import {
  DiscountCategoryRefTracked,
  DiscountCategoryRefMeta,
} from "./discount-category-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DiscountInstanceRef,
  DiscountInstanceRefOptional,
  DiscountInstanceRefMetaI,
  DiscountInstanceRefTrackedI,
} from "./discount-instance-ref";
import {
  DiscountInstanceRefTracked,
  DiscountInstanceRefMeta,
} from "./discount-instance-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DiscountRef,
  DiscountRefOptional,
  DiscountRefMetaI,
  DiscountRefTrackedI,
} from "./discount-ref";
import { DiscountRefTracked, DiscountRefMeta } from "./discount-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ItemDiscountRef,
  ItemDiscountRefOptional,
  ItemDiscountRefMetaI,
  ItemDiscountRefTrackedI,
} from "./item-discount-ref";
import {
  ItemDiscountRefTracked,
  ItemDiscountRefMeta,
} from "./item-discount-ref";

/**
 *
 * @export
 * @interface DiscountFull
 */
export interface DiscountFullOptional extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof DiscountFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DiscountFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof DiscountFull
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof DiscountFull
   */
  tempID?: string;
  /**
   *
   * @type {string}
   * @memberof DiscountFull
   */
  discountName?: string;
  /**
   *
   * @type {CatalogRef}
   * @memberof DiscountFull
   */
  catalogId?: CatalogRefOptional;
  /**
   *
   * @type {Array<DiscountCategoryRef>}
   * @memberof DiscountFull
   */
  categories?: DiscountCategoryRefOptional[];
  /**
   *
   * @type {Array<DiscountInstanceRef>}
   * @memberof DiscountFull
   */
  instances?: DiscountInstanceRefOptional[];
  /**
   *
   * @type {Array<ItemDiscountRef>}
   * @memberof DiscountFull
   */
  itemDiscounts?: ItemDiscountRefOptional[];
}

export interface DiscountFull
  extends DiscountFullOptional, Deletable, DiscountBase, DiscountRef {
  /**
   *
   * @type {boolean}
   * @memberof DiscountFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DiscountFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof DiscountFull
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof DiscountFull
   */
  tempID?: string;
  /**
   *
   * @type {string}
   * @memberof DiscountFull
   */
  discountName: string;
  /**
   *
   * @type {CatalogRef}
   * @memberof DiscountFull
   */
  catalogId?: CatalogRef;
  /**
   *
   * @type {Array<DiscountCategoryRef>}
   * @memberof DiscountFull
   */
  categories?: DiscountCategoryRef[];
  /**
   *
   * @type {Array<DiscountInstanceRef>}
   * @memberof DiscountFull
   */
  instances?: DiscountInstanceRef[];
  /**
   *
   * @type {Array<ItemDiscountRef>}
   * @memberof DiscountFull
   */
  itemDiscounts?: ItemDiscountRef[];
}

export interface DiscountFullTrackedI extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof DiscountFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DiscountFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof DiscountFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DiscountFull
   */
  tempID?: string;
  tempIDIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DiscountFull
   */
  discountName?: string;
  discountNameIsSet: boolean;
  /**
   *
   * @type {CatalogRef}
   * @memberof DiscountFull
   */
  catalogId?: CatalogRefTrackedI;
  catalogIdIsSet: boolean;
  /**
   *
   * @type {Array<DiscountCategoryRef>}
   * @memberof DiscountFull
   */
  categories?: DiscountCategoryRefTrackedI[];
  categoriesIsSet: boolean;
  /**
   *
   * @type {Array<DiscountInstanceRef>}
   * @memberof DiscountFull
   */
  instances?: DiscountInstanceRefTrackedI[];
  instancesIsSet: boolean;
  /**
   *
   * @type {Array<ItemDiscountRef>}
   * @memberof DiscountFull
   */
  itemDiscounts?: ItemDiscountRefTrackedI[];
  itemDiscountsIsSet: boolean;
}

transformDatesMap.set("DiscountFull", function (model: DiscountFull) {
  const transformDatescatalogId = transformDatesMap.get("CatalogRef");
  if (transformDatescatalogId && model.catalogId) {
    transformDatescatalogId(model.catalogId);
  }
  const transformDatescategories = transformDatesMap.get("DiscountCategoryRef");
  if (transformDatescategories) {
    model.categories?.forEach((sub) => {
      transformDatescategories(sub);
    });
  }
  const transformDatesinstances = transformDatesMap.get("DiscountInstanceRef");
  if (transformDatesinstances) {
    model.instances?.forEach((sub) => {
      transformDatesinstances(sub);
    });
  }
  const transformDatesitemDiscounts = transformDatesMap.get("ItemDiscountRef");
  if (transformDatesitemDiscounts) {
    model.itemDiscounts?.forEach((sub) => {
      transformDatesitemDiscounts(sub);
    });
  }
});

export type DiscountFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  tempID: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  discountName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  catalogId: PropertyMeta<CatalogRefMetaI>;
  //isDate: false
  //isDatetime: false
  categories: PropertyMeta<DiscountCategoryRefMetaI>;
  //isDate: false
  //isDatetime: false
  instances: PropertyMeta<DiscountInstanceRefMetaI>;
  //isDate: false
  //isDatetime: false
  itemDiscounts: PropertyMeta<ItemDiscountRefMetaI>;
}>;

export var DiscountFullMeta: DiscountFullMetaI = {} as DiscountFullMetaI;
DiscountFullMeta = typeMeta("DiscountFull", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  tempID: propertyMeta("tempID", false, false, false, MetaTypesBase.string),
  discountName: propertyMeta(
    "discountName",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  catalogId: propertyMeta("catalogId", false, false, false, CatalogRefMeta),
  categories: propertyMeta(
    "categories",
    true,
    false,
    false,
    DiscountCategoryRefMeta,
  ),
  instances: propertyMeta(
    "instances",
    true,
    false,
    false,
    DiscountInstanceRefMeta,
  ),
  itemDiscounts: propertyMeta(
    "itemDiscounts",
    true,
    false,
    false,
    ItemDiscountRefMeta,
  ),
});

const metaI = DiscountFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
  metaI.interfaces = metaI.interfaces.concat([DiscountRefMeta]);
  metaI.assignId.inheritedFrom = DiscountRefMeta.assignId;
  metaI.tempID.inheritedFrom = DiscountRefMeta.tempID;
  metaI.interfaces = metaI.interfaces.concat([DiscountBaseMeta]);
  metaI.discountName.inheritedFrom = DiscountBaseMeta.discountName;
});

export class DiscountFullTracked
  extends DeletableTracked
  implements DiscountFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  tempID__I?: string = undefined;
  tempIDIsSet: boolean = false;
  set tempID(v: undefined | string) {
    if (v !== undefined) {
      this.tempID__I = v;
      this.tempIDIsSet = true;
    } else {
      this.tempID__I = v || undefined;
      this.tempIDIsSet = false;
    }
    this.changeTracker = true;
  }
  get tempID() {
    return this.tempID__I;
  }
  discountName__I?: string = undefined;
  discountNameIsSet: boolean = false;
  set discountName(v: undefined | string) {
    if (v !== undefined) {
      this.discountName__I = v;
      this.discountNameIsSet = true;
    } else {
      this.discountName__I = v || undefined;
      this.discountNameIsSet = true;
    }
    this.changeTracker = true;
  }
  get discountName() {
    return this.discountName__I;
  }
  catalogId__I?: CatalogRefTracked = undefined;
  catalogIdIsSet: boolean = false;
  set catalogId(v: undefined | CatalogRefTracked) {
    if (v !== undefined) {
      this.catalogId__I = v;
      this.catalogIdIsSet = true;
    } else {
      this.catalogId__I = v || undefined;
      this.catalogIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get catalogId() {
    return this.catalogId__I;
  }
  categories__I?: DiscountCategoryRefTracked[] = undefined;
  categoriesIsSet: boolean = false;
  set categories(v: undefined | DiscountCategoryRefTracked[]) {
    if (v !== undefined) {
      this.categories__I = v;
      this.categoriesIsSet = true;
    } else {
      this.categories__I = v || undefined;
      this.categoriesIsSet = false;
    }
    this.changeTracker = true;
  }
  get categories() {
    return this.categories__I;
  }
  instances__I?: DiscountInstanceRefTracked[] = undefined;
  instancesIsSet: boolean = false;
  set instances(v: undefined | DiscountInstanceRefTracked[]) {
    if (v !== undefined) {
      this.instances__I = v;
      this.instancesIsSet = true;
    } else {
      this.instances__I = v || undefined;
      this.instancesIsSet = false;
    }
    this.changeTracker = true;
  }
  get instances() {
    return this.instances__I;
  }
  itemDiscounts__I?: ItemDiscountRefTracked[] = undefined;
  itemDiscountsIsSet: boolean = false;
  set itemDiscounts(v: undefined | ItemDiscountRefTracked[]) {
    if (v !== undefined) {
      this.itemDiscounts__I = v;
      this.itemDiscountsIsSet = true;
    } else {
      this.itemDiscounts__I = v || undefined;
      this.itemDiscountsIsSet = false;
    }
    this.changeTracker = true;
  }
  get itemDiscounts() {
    return this.itemDiscounts__I;
  }
  constructor(config?: DiscountFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;
    if (this.tempIDIsSet == true && other?.tempIDIsSet == true)
      return this.tempID == other.tempID;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.catalogId?.setIds();

    this.categories?.forEach((a) => a.setIds());

    this.instances?.forEach((a) => a.setIds());

    this.itemDiscounts?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: DiscountFullOptional,
    options?: AssignOptions,
  ): DiscountFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.tempID && this.tempIDApplyFilter(optionsRequired.filter)) {
      this.tempID = config.tempID;
      if (optionsRequired.unassign) this.tempIDIsSet = false;
      else this.tempIDIsSet = true;
    }
    if (
      config.discountName &&
      this.discountNameApplyFilter(optionsRequired.filter)
    ) {
      this.discountName = config.discountName;
      if (optionsRequired.unassign) this.discountNameIsSet = false;
      else this.discountNameIsSet = true;
    }
    if (config.catalogId && this.catalogIdApplyFilter(optionsRequired.filter)) {
      this.catalogId = new CatalogRefTracked(config.catalogId, options);
      if (optionsRequired.unassign) this.catalogIdIsSet = false;
      else this.catalogIdIsSet = true;
    }
    if (
      config.categories &&
      this.categoriesApplyFilter(optionsRequired.filter)
    ) {
      this.categories = config.categories?.map(
        (a) => new DiscountCategoryRefTracked(a, options),
      );
      if (optionsRequired.unassign) this.categoriesIsSet = false;
      else this.categoriesIsSet = true;
    }
    if (config.instances && this.instancesApplyFilter(optionsRequired.filter)) {
      this.instances = config.instances?.map(
        (a) => new DiscountInstanceRefTracked(a, options),
      );
      if (optionsRequired.unassign) this.instancesIsSet = false;
      else this.instancesIsSet = true;
    }
    if (
      config.itemDiscounts &&
      this.itemDiscountsApplyFilter(optionsRequired.filter)
    ) {
      this.itemDiscounts = config.itemDiscounts?.map(
        (a) => new ItemDiscountRefTracked(a, options),
      );
      if (optionsRequired.unassign) this.itemDiscountsIsSet = false;
      else this.itemDiscountsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): DiscountFullTrackedI {
    const cloned = {} as DiscountFullTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.tempIDIsSetDeep() &&
      this.tempIDApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tempIDIsSet = true;
      cloned.tempID = this.tempID;
    } else {
      //cloned.tempIDIsSet = false
    }
    if (
      this.discountNameIsSetDeep() &&
      this.discountNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.discountNameIsSet = true;
      cloned.discountName = this.discountName;
    } else {
      //cloned.discountNameIsSet = false
    }
    if (
      this.catalogIdIsSetDeep() &&
      this.catalogIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.catalogIdIsSet = true;
      cloned.catalogId = this.catalogId?.removeUnset(filter);
    } else {
      //cloned.catalogIdIsSet = false
    }
    if (
      this.categoriesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.categoriesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.categoriesIsSet = true;
      cloned.categories = this.categories
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.categoriesIsSet = false
    }
    if (
      this.instancesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.instancesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instancesIsSet = true;
      cloned.instances = this.instances
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.instancesIsSet = false
    }
    if (
      this.itemDiscountsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.itemDiscountsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemDiscountsIsSet = true;
      cloned.itemDiscounts = this.itemDiscounts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.itemDiscountsIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): DiscountFullTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.tempIDApplyFilter(filter)) this.tempIDIsSet = false;

    if (!this.discountNameApplyFilter(filter)) this.discountNameIsSet = false;

    if (!this.catalogIdApplyFilter(filter)) this.catalogIdIsSet = false;
    this.catalogId?.unassignAll(filter);

    if (!this.categoriesApplyFilter(filter)) this.categoriesIsSet = false;

    this.categories?.forEach((a) => a.unassignAll(filter));
    if (!this.instancesApplyFilter(filter)) this.instancesIsSet = false;

    this.instances?.forEach((a) => a.unassignAll(filter));
    if (!this.itemDiscountsApplyFilter(filter)) this.itemDiscountsIsSet = false;

    this.itemDiscounts?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DiscountFullMeta.isDeleted,
      DiscountFullMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(DiscountFullMeta.isNew, DiscountFullMeta, this.isNew, this);
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DiscountFullMeta.assignId,
      DiscountFullMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  tempIDApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(DiscountFullMeta.tempID, DiscountFullMeta, this.tempID, this);
  }
  tempIDIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tempIDIsSet && this.tempIDApplyFilter(filter)) return true;

    return false;
  }
  discountNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DiscountFullMeta.discountName,
      DiscountFullMeta,
      this.discountName,
      this,
    );
  }
  discountNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.discountNameIsSet && this.discountNameApplyFilter(filter))
      return true;

    return false;
  }
  catalogIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DiscountFullMeta.catalogId,
      DiscountFullMeta,
      this.catalogId,
      this,
    );
  }
  catalogIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.catalogIdIsSet && this.catalogIdApplyFilter(filter)) return true;
    return this.catalogId?.anySet(filter) == true;

    return false;
  }
  categoriesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DiscountFullMeta.categories,
      DiscountFullMeta,
      this.categories,
      this,
    );
  }
  categoriesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.categoriesIsSet && this.categoriesApplyFilter(filter)) return true;

    return this.categories?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  instancesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DiscountFullMeta.instances,
      DiscountFullMeta,
      this.instances,
      this,
    );
  }
  instancesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.instancesIsSet && this.instancesApplyFilter(filter)) return true;

    return this.instances?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  itemDiscountsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DiscountFullMeta.itemDiscounts,
      DiscountFullMeta,
      this.itemDiscounts,
      this,
    );
  }
  itemDiscountsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemDiscountsIsSet && this.itemDiscountsApplyFilter(filter))
      return true;

    return this.itemDiscounts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.tempIDIsSetDeep(filter)) return true;
    if (this.discountNameIsSetDeep(filter)) return true;
    if (this.catalogIdIsSetDeep(filter)) return true;
    if (this.categoriesIsSetDeep(filter)) return true;
    if (this.instancesIsSetDeep(filter)) return true;
    if (this.itemDiscountsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
